import React, { useState, useEffect } from 'react';
import { YIcon, YModal, YUpload } from '@ywfe/ywd';
import { Button, Form, Input, Select, Cascader, message, Checkbox, Alert } from 'antd';
import { useGetAPI25060, usePostAPI25087, usePostAPI25051, useGetAPI20970 } from '../generated/api';
import { NavIconItemStyle } from './styles';
import {menuStyle} from "@auth/auth.user";

const { Option } = Select;
const { TextArea } = Input;

interface ProblemInterface {
  isIcon: number; // 0是没有，1是有ICON
  inMenu?:boolean
}

export const SendProblem = (props: ProblemInterface) => {
  const { isIcon = 0,inMenu = false } = props;
  const [isHidden, setIsHidden] = useState(false);
  const [visible, setVisible] = useState(false);
  const [online, setLine] = useState(true);
  const [problemTypeList, setProblemTypeList] = useState([]);
  const [desktopHomeCommonEntryTree, setDesktopHomeCommonEntryTree] = useState([]);
  const { fetchAPI25060Data } = useGetAPI25060();
  const { fetchAPI25087Data } = usePostAPI25087();
  const { fetchAPI25051Data } = usePostAPI25051();
  const { fetchAPI20970Data } = useGetAPI20970();

  useEffect(() => {
    getProblemTypeList();
    if (window.location.href.includes('login')) {
      // 登录页面
      setLine(false);
    } else {
      setLine(true);
      fetchAPI20970DataApi();
    }
  }, []);

  const methodArgs = {
    request: fetchAPI25087Data,
  };

  const args = {
    ...methodArgs,
    quantity: 2,
  };

  const onChangeIsHidden = (e: any) => {
    setIsHidden(e.target.checked);
  };

  const changeVisible = () => {
    setVisible(true);
  };

  const getProblemTypeList = async () => {
    const res = await fetchAPI25060Data();
    if (res) {
      setProblemTypeList((res.list || []) as any);
    }
    return res || [];
  };

  // 项目目录树初始化
  const initProjectTreeData = (obj: any) => {
    const opt: any = obj || [];
    if (opt) {
      const currentArr: any[] = [];
      // eslint-disable-next-line array-callback-return
      opt.map((ele: any) => {
        const obj2: any = {
          ...ele,
          value: ele.cloudCategoryId || ele.moduleId || ele.resourceId,
          label: ele.cloudCategoryName || ele.moduleName || ele.resourceName,
        };
        if (ele.moduleList) {
          obj2.children = initProjectTreeData(ele.moduleList);
        } else if (ele.resourceList) {
          obj2.children = initProjectTreeData(ele.resourceList);
        }
        currentArr.push(obj2);
      });
      return currentArr;
    }
    return [];
  };

  const fetchAPI20970DataApi = async () => {
    const res = await fetchAPI20970Data();
    if (res) {
      const data = (res.list || []) as any;
      setDesktopHomeCommonEntryTree(initProjectTreeData(data) as any);
    }
    return res || [];
  };

  const getNavigator = () => navigator.userAgent;

  const onFinish = async (values: any) => {
    let pictureUrls = '';
    if (values.pictureUrls && values.pictureUrls.length === 1) {
      pictureUrls = values.pictureUrls[0].url;
    } else if (values.pictureUrls && values.pictureUrls.length) {
      values.pictureUrls.forEach((item: any) => {
        pictureUrls = `${pictureUrls},${item.url}`;
      });
    }
    const params: any = {
      ...values,
      pictureUrls,
      href: window.location.href,
      userAgent: getNavigator(),
      resourceId: values.resourceId ? values.resourceId[values.resourceId.length - 1] : null,
    };
    if (isHidden === true) {
      params.name = '匿名用户';
    } else if (!params.name) {
      message.warning('请填写用户名称！');
      return;
    }
    const resData: any = await fetchAPI25051Data({
      ...params,
    });
    if (resData) {
      message.success('提交成功！');
      setVisible(false);
    } else {
      message.error('提交失败！');
    }
  };

  const jumpCenter = () => {
    window.open('https://lexiangla.com/threads?type=sub&category_id=bb37b13aa37611ec9929da98d9b289e0&company_from=7e2e5a3e689611ecb3391a0f69f4fe5f');
  };

  return (
    <>
      {
        inMenu ? <div style={menuStyle} onClick={changeVisible}>
          <img style={{width:16,height:16,marginRight:8}} src="https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/synergy/home/icon-问题反馈.png" alt=""/>
          <div>问题反馈</div>
        </div> : isIcon ? (
          <NavIconItemStyle>
            <div className="entry" onClick={changeVisible}>
              <YIcon name="ywcloudIconwentifankui" size="20px" version="20220301" />
              <span className="name">问题反馈</span>
            </div>
          </NavIconItemStyle>
        ) : (
          <span style={{ marginTop: '5px', cursor: 'pointer' }} onClick={changeVisible}>
          问题反馈
        </span>
        )
      }
      <YModal
        size="small"
        footer={null}
        width="50%"
        content={() => (
          <Form
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              name: localStorage.getItem('userName') || '',
            }}
          >
            <div
              style={{
                marginBottom: '20px',
              }}
            >
              <Alert
                message=""
                description={(
                  <div
                    style={{
                      color: '#9d9c9c',
                      marginTop: '-8px',
                    }}
                  >
                    您可以前往“遥望云问题反馈”专区和其他同学进行互动，您的问题可能获得优先解决
                    <span
                      onClick={jumpCenter}
                      style={{
                        cursor: 'pointer',
                        color: '#2890fb',
                        marginLeft: '20px',
                      }}
                    >
                      前往“遥望云问题反馈”专区&gt;
                    </span>
                  </div>
                )}
                type="info"
                showIcon
              />
            </div>
            <div>
              {!isHidden ? (
                <Form.Item style={{ display: 'inline-block', width: '70%' }} label="用户名" name="name">
                  <Input maxLength={20} />
                </Form.Item>
              ) : (
                <Form.Item style={{ display: 'inline-block', width: '70%' }} label="用户名">
                  <Input maxLength={20} value="匿名用户" disabled />
                </Form.Item>
              )}
              <Checkbox style={{ marginLeft: '10px', marginTop: '35px' }} checked={isHidden} onChange={onChangeIsHidden}>
                是否匿名
              </Checkbox>
            </div>

            <Form.Item label="问题分类" name="questionType" rules={[{ required: true, message: '请选择问题分类!' }]}>
              <Select style={{ width: '100%' }}>
                {problemTypeList.map((item: any) => (
                  <Option value={item.id} key={item.id}>
                    {item.questionTypeDesc}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            {online ? (
              <Form.Item label="所属页面" name="resourceId" rules={[{ required: true, message: '请选择所属页面!' }]}>
                <Cascader options={desktopHomeCommonEntryTree} placeholder="请选择所属页面" />
              </Form.Item>
            ) : (
              <></>
            )}

            <Form.Item label="问题描述" name="desc" rules={[{ required: true, message: '请输入问题描述!' }]}>
              <TextArea autoSize={{ minRows: 2, maxRows: 4 }} />
            </Form.Item>

            <Form.Item label="联系方式（可选）" name="contactDetails" rules={[{ required: false }]}>
              <Input maxLength={20} />
            </Form.Item>
            <Form.Item label="上传问题截图（可选）" name="pictureUrls" rules={[{ required: false }]}>
              <YUpload {...args} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                提交
              </Button>
            </Form.Item>
          </Form>
        )}
        visible={visible}
        okText="提交"
        title="问题反馈"
        onOk={() => {
          setVisible(false);
        }}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </>
  );
};
